import React from 'react';
import PropTypes from 'prop-types';
import { ThemeSetup } from '../themes/ThemeSetup';

// EXAMPLE:
// class Main extends React.Component {
//   state = {
//     entries: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
//     loading: false
//   };
//
//   render() {
//     return (
//       <Scrollable style={ { height: 100 } }
//                   loading={ this.state.loading }
//                   onReachBottom={ this.loadMore.bind(this) }>
//         { _.map(this.state.entries, (entry, index) => <div key={ index }>{ index }</div>) }
//       </Scrollable>
//     );
//   }
//
//   loadMore() {
//     if (this.state.loading == false && this.state.entries.length < 100) {
//       this.setState({ loading: true });
//       setTimeout(() => {
//         for (var i = 0; i < 15; i++) this.state.entries.push('string')
//         this.state.loading = false;
//         this.setState(this.state);
//       }, 5000);
//     }
//   }
// }

export default class Scrollable extends React.Component {
  static propTypes = {
    style: PropTypes.any.isRequired, // styles to position the root box of Scrollable
    loading: PropTypes.any.isRequired, // whether to display loader at the bottom
    onReachBottom: PropTypes.any.isRequired, // callback which is called when user reaches the bottom of the box container
    children: PropTypes.any.isRequired // the scrollable content itself
  };

  render() {
    return (
      <div onScroll={this.onScroll.bind(this)} style={{ ...this.props.style, overflowY: 'scroll' }}>
        {this.props.children}
        {this.props.loading ? <div style={styles.loader} /> : null}
      </div>
    );
  }

  onScroll(event) {
    if (event.target.scrollTop + event.target.clientHeight == event.target.scrollHeight) {
      this.props.onReachBottom();
    }
  }
}

const styles = {
  loader: {
    height: '60px',
    width: '100%',
    backgroundImage: ThemeSetup.getBackgroundURL('RingSpinner.svg'),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain'
  }
};
